import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';
import MiddleBlock from '../MiddleBlock/MiddleBlock';
import logo from "../../images/logo.png"

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const closeOnResize = () => {
      if (window.innerWidth > 760) setMenuOpen(false);
    };
    window.addEventListener('resize', closeOnResize);
    return () => window.removeEventListener('resize', closeOnResize);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="nav">
        <MiddleBlock>
            <div className="navContainer">
                <div className="logo">
                    <NavLink to="/">
                        <img className="logoImg" src={ logo } alt="QUENA" />
                    </NavLink>
                </div>
                <button
                    type="button"
                    className={`navToggle ${menuOpen ? 'is-open' : ''}`}
                    onClick={() => setMenuOpen((current) => !current)}
                    aria-label={menuOpen ? 'Zamknij menu' : 'Otwórz menu'}
                    aria-expanded={menuOpen}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <ul className={`navLinks ${menuOpen ? 'is-open' : ''}`}>
                    <li>
                        <NavLink 
                            to="/about" 
                            onClick={closeMenu}
                            className={({ isActive }) => 
                                isActive ? `link active` : `link`
                            }
                        >
                            O NAS
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to="/events" 
                            onClick={closeMenu}
                            className={({ isActive }) => 
                                isActive ? `link active` : `link`
                            }
                        >
                            WYDARZENIA
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to="/support" 
                            onClick={closeMenu}
                            className={({ isActive }) => 
                                isActive ? `link active` : `link`
                            }
                        >
                            WSPARCIE
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                            to="/contact" 
                            onClick={closeMenu}
                            className={({ isActive }) => 
                                isActive ? `link active` : `link`
                            }
                        >
                            KONTAKT
                        </NavLink>
                    </li>
                </ul>
            </div>
        </MiddleBlock>
    </nav>
  );
};

export default Navigation;
